<template>
  <b-overlay>
    <b-nav-item-dropdown
      class="dropdown-notification mr-25"
      menu-class="dropdown-menu-media"
      right
    >
      <template #button-content>
        <feather-icon
          :badge="countNotification"
          badge-classes="bg-danger"
          class="text-body"
          icon="BellIcon"
          size="21"
        />
      </template>

      <!-- Header -->
      <li class="dropdown-menu-header">
        <div class="dropdown-header d-flex">
          <h4 class="notification-title mb-0 mr-auto">
            การแจ้งเตือน 🎉
          </h4>
          <b-badge pill variant="light-primary">
            {{ countNotification }} ใหม่
          </b-badge>
        </div>
      </li>

      <!-- Notifications -->
      <vue-perfect-scrollbar
        :settings="perfectScrollbarSettings"
        class="scrollable-container media-list scroll-area"
        tagname="li"
      >
        <!-- Account Notification -->
        <b-link
          v-for="notification in showNotification"
          :key="notification.notificationId"
          @click="selectIssueNotification(notification)"
        >
          <!-- (1) Read:No, IsDarkMode:False -->
          <b-media
            v-if="notification.readDate === null && isDarkMode === false"
            style="background-color: #eeedfd;"
          >
            <!-- title -->
            <p class="media-heading">
              <span class="font-weight-bolder">
                {{ notification.title }}
              </span>
            </p>
            <!-- maintitle -->
            <small class="notification-text">{{ notification.maintitle }}</small
            ><br />
            <!-- subtitle -->
            <small class="notification-text">{{ notification.subtitle }}</small>
          </b-media>
          <!-- (2) ead:No, IsDarkMode:True -->
          <b-media
            v-else-if="notification.readDate === null && isDarkMode === true"
            style="background-color: #161d31;"
          >
            <!-- title -->
            <p class="media-heading">
              <span class="font-weight-bolder">
                {{ notification.title }}
              </span>
            </p>
            <!-- maintitle -->
            <small class="notification-text">{{ notification.maintitle }}</small
            ><br />
            <!-- subtitle -->
            <small class="notification-text">{{ notification.subtitle }}</small>
          </b-media>
          <!-- (3) Read:Yes -->
          <b-media v-else>
            <!-- title -->
            <p class="media-heading">
              <span class="font-weight-bolder">
                {{ notification.title }}
              </span>
            </p>
            <!-- maintitle -->
            <small class="notification-text">{{ notification.maintitle }}</small
            ><br />
            <!-- subtitle -->
            <small class="notification-text">{{ notification.subtitle }}</small>
          </b-media>
        </b-link>

        <!-- System Notification Toggler -->
        <!-- <div class="media d-flex align-items-center">
        <h6 class="font-weight-bolder mr-auto mb-0">
          System Notifications
        </h6>
        <b-form-checkbox
          :checked="true"
          switch
        />
      </div> -->

        <!-- System Notifications -->
        <!-- <b-link
        v-for="notification in systemNotifications"
        :key="notification.subtitle"
      >
        <b-media>
          <template #aside>
            <b-avatar
              size="32"
              :variant="notification.type"
            >
              <feather-icon :icon="notification.icon" />
            </b-avatar>
          </template>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ notification.title }}
            </span>
          </p>
          <small class="notification-text">{{ notification.subtitle }}</small>
        </b-media>
      </b-link> -->
      </vue-perfect-scrollbar>

      <!-- Cart Footer -->
      <!-- <li class="dropdown-menu-footer">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          block
          @click="readNotificationAll()"
        >
          อ่านทั้งหมด
        </b-button>
      </li> -->
    </b-nav-item-dropdown>
  </b-overlay>
</template>

<script>
import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
  BButton,
  BFormCheckbox,
  BPagination,
  BFormSelect,
  BOverlay,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Ripple from "vue-ripple-directive";

import { getUserData } from "@/auth/utils";
import appsettings from "@/store/app-settings";
import * as notificationStore from "@/store/api/notification/index.js";

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
    BPagination,
    BFormSelect,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  props: {
    objNotification: {},
  },
  data() {
    return {
      dataNotification: [],
      showNotification: [],
      countNotification: 0,
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },
      pageLength: 10,
      isDarkMode: false,
    };
  },
  // setup(props) {
  //   /* eslint-disable global-require */
  //   const notifications = [
  //     {
  //       title: 'Congratulation Sam 🎉',
  //       avatar: require('@/assets/images/avatars/6-small.png'),
  //       subtitle: 'Won the monthly best seller badge',
  //       type: 'light-success',
  //     },
  //     {
  //       title: 'New message received',
  //       avatar: require('@/assets/images/avatars/9-small.png'),
  //       subtitle: 'You have 10 unread messages',
  //       type: 'light-info',
  //     },
  //     {
  //       title: 'Revised Order 👋',
  //       avatar: 'MD',
  //       subtitle: 'MD Inc. order updated',
  //       type: 'light-danger',
  //     },
  //   ]
  //   /* eslint-disable global-require */

  //   const systemNotifications = [
  //     {
  //       title: 'Server down',
  //       subtitle: 'USA Server is down due to hight CPU usage',
  //       type: 'light-danger',
  //       icon: 'XIcon',
  //     },
  //     {
  //       title: 'Sales report generated',
  //       subtitle: 'Last month sales report generated',
  //       type: 'light-success',
  //       icon: 'CheckIcon',
  //     },
  //     {
  //       title: 'High memory usage',
  //       subtitle: 'BLR Server using high memory',
  //       type: 'light-warning',
  //       icon: 'AlertTriangleIcon',
  //     },
  //   ]

  //   const perfectScrollbarSettings = {
  //     maxScrollbarLength: 60,
  //     wheelPropagation: false,
  //   }

  //   console.log("notifications", notifications);
  //   return {
  //     notifications,
  //     systemNotifications,
  //     perfectScrollbarSettings,
  //   }
  // },
  mounted() {
    // get notification
    this.getComplaintNotification();
    // event click bell dropdown
    this.$root.$on("bv::dropdown::show", (bvEvent) => {
      console.log("Notification is about to be shown", bvEvent);
      this.isDarkMode = document.body.classList.contains("dark-layout");
      this.readNotificationAll();
    });
  },
  create() {},
  methods: {
    getComplaintNotification() {
      const _this = this;
      console.log("obj-params", this.objNotification);

      notificationStore
        .getComplaintNotification(this.objNotification)
        .then((response) => {
          if (response.data.success) {
            this.dataNotification = response.data.data;

            console.log("obj-data", response.data.data);

            if (
              this.dataNotification !== null &&
              this.dataNotification !== undefined
            ) {
              this.dataNotification.forEach((o) => {
                const setNoti = {
                  notificationId: o.id,
                  urlRedirect: o.urlRedirect,
                  userId: o.userId,
                  complaintId: o.complaintId,
                  departmentId: o.departmentId,
                  roleId: o.roleId,
                  title: o.title,
                  maintitle: o.mainDetail,
                  subtitle: o.subDetail,
                  readDate: o.readDate, // mark notification read yes or no
                  type: "light-success",
                };
                this.showNotification.push(setNoti);
              });
            }

            // count notification
            // this.countNotification = this.showNotification.length;
            const result = this.dataNotification.filter(
              (o) => o.readDate == null,
            );
            // console.log("result", result);
            this.countNotification = result.length;

            // console.log("obj-show", this.showNotification);
            // console.log(
            //   "getComplaintNotification Count",
            //   this.countNotification
            // );

            this.$forceUpdate();
          } else {
            this.showNotification = null;
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getComplaintGone(notification) {
      const params = {
        userId: notification.userId,
        complaintId: notification.complaintId,
        departmentId: notification.departmentId,
        roleId: notification.roleId,
      };

      notificationStore
        .getComplaintGone(params)
        .then((response) => {
          console.log("check response", response);
        })
        .catch((error) => {
          console.log("error", error);
          return null;
        });
    },
    selectIssueNotification(notification) {
      // const temp = {
      //   userId: notification.userId,
      //   complaintId: notification.complaintId,
      //   departmentId: notification.departmentId,
      //   roleId: notification.roleId,
      //   urlRedirect: notification.urlRedirect,
      //   title: notification.title,
      //   province: this.objNotification.provinceCode,
      // }

      // console.log("parameter notification", notification);
      // console.log("parameter this.objNotification", this.objNotification);
      // console.log("select temp", temp);

      notificationStore
        .readNotificationIssue(
          notification.userId,
          notification.complaintId,
          notification.departmentId,
          notification.roleId,
          notification.urlRedirect,
          notification.title,
          this.objNotification.provinceCode,
        )
        .then((response) => {
          console.log("return url issue", response.data);
          if (response.status === 200) {
            const userData = getUserData();

            if (
              userData &&
              userData.selectUserRole &&
              userData.selectUserRole.value &&
              userData.selectUserRole.value.toLowerCase() ===
                appsettings.complaintRoleId.bangkok.toLowerCase()
            ) {
              this.gotoIssue(notification.urlRedirect);
            } else {
              this.gotoIssue(response.data);
            }
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    gotoIssue(urlRedirect) {
      console.log("gotoIssue", urlRedirect);

      window.open(urlRedirect, "_self");
      // self.$router.push({
      //   name: "servicecentercomplaintConfirm",
      //   query: {
      //     parentComponent: self.parentComponent,
      //     complaintGuid: response.data.data,
      //     //isGroupGuid: true,
      //   },
      // });

      this.resetShowNotification();
      this.getComplaintNotification();
    },
    readNotificationAll() {
      // console.log("read all notification parameter", this.objNotification);
      notificationStore
        .readNotificationAll(
          this.objNotification.userId,
          this.objNotification.roleId,
        )
        .then((response) => {
          // console.log("read all notification response", response);
          if (response.status === 200) {
            this.countNotification = 0; // when click bell count is zero
            this.$forceUpdate();
            // console.log("this.$router.currentRoute", this.$router.currentRoute);
            // this.$router.go(this.$router.currentRoute); // reload ปัจจุบันที่เขาเปิดอยู่
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    resetShowNotification() {
      this.showNotification = [];
    },
  },
};
</script>

<style></style>
